import React from "react";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/styles";
import { createStyles } from "@material-ui/core";
const useStyles = makeStyles((theme) =>
  createStyles({
    yes: {
      backgroundColor: theme.palette.primary.main,
      color: "#000",
      fontSize: 16,
      height: 36,
      width: 128,
      "&:hover": {
        backgroundColor: theme.palette.primary.light,
      },
    },
    delete: {
      backgroundColor: theme.palette.error.main,
      color: "#fff",
      fontSize: 16,
      height: 36,
      width: 128,
      "&:hover": {
        backgroundColor: theme.palette.error.light,
      },
    },
    no: {
      backgroundColor: theme.palette.grey["300"],
      color: "#000",
      fontSize: 16,
      height: 36,
      width: 128,
      "&:hover": {
        backgroundColor: theme.palette.grey["200"],
      },
    },
  })
);

const DialogButton = (props) => {
  const classes = useStyles();
  return (
    <Button
      className={
        props.mode === "delete"
          ? classes.delete
          : props.mode === "yes"
          ? classes.yes
          : classes.no
      }
      variant="contained"
      onClick={() => props.onClick()}
    >
      {props.label}
    </Button>
  );
};

export default DialogButton;
